;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');

	Collection.ContactUsCategories = Backbone.Collection.extend({

		initialize: function(){
			this.add([
				{val:'Password and logging in', label: 'Password and logging in'},
				{val:'My Account & Subscriptions', label: 'My Account & Subscriptions'},
				{val:'Assistant Coach', label: 'Assistant Coach'},
				{val:'Gameplay questions', label: 'Gameplay questions'},
				{val:'Finals and playoffs', label: 'Finals and playoffs'},
				{val:'Mobile and Apps', label: 'Mobile and Apps'},
				{val:'Team management', label: 'Team management'},
				{val:'Trades', label: 'Trades'},
				{val:'Errors', label: 'Errors'}
			]);
		},

		sync: function() { return null; },
		fetch: function() { return null; },
		save: function() { return null; }
	});

}(window, APP, Backbone, Marionette, $, _));